/* global globalThis */
import { Button, Layout, Typography } from "antd";
import React from "react";
import { CONTACT, LOGO_SVG_URL } from "../constants/common";
import { ROUTES } from "../constants/Route";

const { Content, Header } = Layout;
const { Title, Text } = Typography;

const DocumentLinkError = () => {

  return (
    <Layout className="bg-white min-h-screen">
      <Header className="welcome-footer bg-white">
        <img
          alt="Provider1st Logo"
          className="mt-4 mx-auto"
          src={globalThis.location.origin + LOGO_SVG_URL}
        />
      </Header>
      <Content>
        <div className="container mx-auto max-w-3xl text-center">
          <div className="mx-auto mt-8 mb-8 flex h-28 w-28 items-center justify-center rounded-full border-8 border-[#1f8acb]">
            <div className="relative h-20 w-20">
              <div className="absolute left-1/2 top-2 h-9 w-1 origin-bottom -rotate-45 rounded bg-slate-700" />
              <div className="absolute left-1/2 top-1/2 h-1 w-8 origin-left rounded bg-slate-700" />
              <div className="absolute left-1/2 top-0 h-full w-1 -translate-x-1/2 bg-red-500/70" />
              <div className="absolute left-1/2 top-0 h-full w-1 -translate-x-1/2 rotate-12 bg-slate-200" />
            </div>
          </div>

          <Title className="!mb-2 !text-2xl md:!text-3xl">
          Invalid/Expired Link
          </Title>
          <Text className="block max-w-2xl mx-auto !text-base text-slate-600">
          The link you are trying to access it no longer available. Please contact the support team for further assistance.  
          </Text>

          <div className="mx-auto mt-10 max-w-2xl text-left">
            <Title level={4} className="!mb-1">
               Contact Support
            </Title>
            <div className="mb-4 h-1 w-full bg-[#1f8acb]" />
            <Text strong>Email : </Text>
            <a className="font-bold text-black" href={`mailto:${CONTACT.EMAIL}`}>
              {CONTACT.EMAIL}
            </a>
            <br />
            <Text strong>Call : </Text>
            <Text strong>{CONTACT.PHONE}</Text>
            <br />
            <Text strong>Fax : </Text>
            <Text strong>{CONTACT.PHONE_DIAL}</Text>
            <br />
            <Text underline>Monday through Friday, between 06:00 AM and 05:00 PM (PST)</Text>
          </div>
        </div>
      </Content>
    </Layout>
  );
};

export default DocumentLinkError;
